import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const SriLankaPage = () => {
  return <DestinationTemplate destinationId="srilanka" />;
};

export default SriLankaPage;
